import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {AuditMixin} from "../../_models/audit-mixin";
import {StringDatePipe} from "../../shared/pipes";
import {ModelID} from "../../_typing/generic-types";
import {GetNamePipe} from "../../shared/pipes/get-name.pipe";
import { AsyncPipe } from "@angular/common";
import {
    LinkedComponentAuditTableComponent
} from "../../tables/linked-component-audit-table/linked-component-audit-table.component";

@Component({
    selector: 'audit-mixin',
    templateUrl: './audit-mixin.component.html',
    styleUrls: ['./audit-mixin.component.less'],
    imports: [
    StringDatePipe,
    GetNamePipe,
    AsyncPipe,
    LinkedComponentAuditTableComponent
],
    encapsulation: ViewEncapsulation.None
})
export class AuditMixinComponent implements OnInit {

    @Input() model: AuditMixin & { id: string; type: string; auditItemId?: ModelID };
    @Input() showTitle = false;
    isAuditExpanded = false;
    showSingle = true;

    constructor() {
    }

    ngOnInit(): void {
        this.showSingle = !this.model.auditItemId || this.model.relationships?.['data']?.length <= 1
    }

    toggleAudit(): void {
        this.isAuditExpanded = !this.isAuditExpanded;
    }
}
